import { Console } from '../console';
import { BridgeNavigator, type BridgeAdapter } from './navigator';

const navigator = new BridgeNavigator();
let bridgeAdapter: BridgeAdapter | undefined = undefined;

export function routeTo(route: string) {
    bridgeAdapter?.routeTo(route);
    Console.log('Bridge routeTo: ' + route);
}

export function register(adapter: BridgeAdapter) {
    bridgeAdapter = adapter;
    Console.log('Registered adapter:' + typeof bridgeAdapter);
}

export function proposeRoute(symbol: string) {
    bridgeAdapter?.proposeRoute(symbol);
    Console.log('Bridge proposeRoute' + symbol);
}

export type ChangeState = 'pending' | 'complete';
let changeHandlers: { [name: string]: (state: ChangeState) => void } = {};
export function onChange(name: string, handler: (state: ChangeState) => void) {
    changeHandlers[name] = handler;
}

export function unregister(name: string) {
    delete changeHandlers[name];
}

export function refreshPending() {
    for (let name of Object.keys(changeHandlers)) {
        Console.log('Bridge: refresh pending');
        changeHandlers[name]('pending');
    }
}

export function refreshReady() {
    for (let name of Object.keys(changeHandlers)) {
        Console.log('Bridge: refresh ready');
        changeHandlers[name]('complete');
    }
}
